
import React from 'react'
import styled from 'styled-components'

import { FirstRow } from './FirstRow'
import { SecondRow } from './SecondRow'
import { ThirdRow } from './ThirdRow'
import { ManDayRow } from './ManDayRow'
import { InputRow } from './InputRow'

export const Detail = React.memo(({
  data,
  type,
  index,
  progressIndex,
  isEditing,
  handleInput,
  handleRemark,
}) => {
  const {
    _last_activity_base,
    _activity_base,
    _cost_base,
    _gap,
    criteria,
  } = data

  const acc = {
    last_percentage: _last_activity_base.accumulate_percentage,
    current_percentage: _activity_base.accumulate_percentage,
    cost_base_percentage: _cost_base.accumulate_percentage,
    gap_percentage: _gap.accumulate_percentage,
    last_revenue: _last_activity_base.accumulate_revenue,
    current_revenue: _activity_base.accumulate_revenue,
    cost_base_revenue: _cost_base.accumulate_revenue,
    gap_revenue: _gap.accumulate_revenue,
  }

  const delta = {
    last_percentage: _last_activity_base.delta_percentage,
    current_percentage: _activity_base.delta_percentage,
    cost_base_percentage: _cost_base.delta_percentage,
    gap_percentage: _gap.delta_percentage,
    last_revenue: _last_activity_base.delta_revenue,
    current_revenue: _activity_base.delta_revenue,
    cost_base_revenue: _cost_base.delta_revenue,
    gap_revenue: _gap.delta_revenue,
  }

  return (
    <Root>
      <LeftWrapper>
        <Col>
          <FirstRow data={ data } />
          <SecondRow data={ data } />
          { criteria === 'MD' &&
            <ManDayRow
              data={ data }
              index={ index }
              progressIndex={ progressIndex }
              isEditing={ isEditing }
              handleInput={ handleInput }
            />
          }
          <ThirdRow
            data={ data }
            index={ index }
            progressIndex={ progressIndex }
            isEditing={ isEditing }
            handleRemark={ handleRemark }
          />
        </Col>
        <Group>
          <TextWrapper>
            <Text color='#2F80ED'>Accumulate</Text>
          </TextWrapper>
          <TextWrapper>
            <Text color='#D44B49'>Delta</Text>
          </TextWrapper>
        </Group>
      </LeftWrapper>
      <Wrapper>
        <InputRow
          index={ index }
          progressIndex={ progressIndex }
          name={ ['accumulate_percentage', 'accumulate_revenue'] }
          criteria={ criteria }
          isEditing={ isEditing }
          data={ acc }
          type={ type }
          handleInput={ handleInput }
        />
        <InputRow
          index={ index }
          progressIndex={ progressIndex }
          name={ ['delta_percentage', 'delta_revenue'] }
          criteria={ criteria }
          isEditing={ isEditing }
          data={ delta }
          handleInput={ handleInput }
        />
      </Wrapper>
    </Root>
  )
})

const Root = styled.div`
  display: flex;
`

const LeftWrapper = styled.div`
  display: flex;
  flex-basis: 40%;
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-basis: 60%;
`

const Col = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding-left: 16px;
`

const Group = styled.div`
  width: 10px;
  display: flex;
  flex-direction: column;
`

const TextWrapper = styled.div`
  height: 100%;
  position: relative;
`

const Text = styled.span`
  position: absolute;
  font-family: NotoSans;
  font-weight: 600;
  font-size: 8px;
  color: ${p => p.color};
  transform:  translateX(-50%) translateY(35px) rotate(-90deg);
`



// WEBPACK FOOTER //
// ./src/components/project-profit-sheet/PercentTable/item/detail/index.js